import React from 'react';

// FormWarrantyClaims.jsx içinde closure fonksiyon olarak tanımlı `renderField`in
// yapısal (davranış değişikliği olmadan) component'e çıkarılmış hali.
const FormField = ({ label, content, required = false }) => (
    <div className="col-12 md:col-4">
        <div className="field">
            <label className="font-bold block">
                {label}
                {required && <span className="text-red-500 ml-1">*</span>}
            </label>
            {content}
        </div>
    </div>
);

export default FormField;
